import {Component, EventEmitter, Inject, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {AuthenticateService} from '../../services/authenticate.service';
import {TokenStorage} from '../../services/token-storage.service';
import {Router} from '@angular/router';
import {AlertService, LoaderService, DataStorageService, DomainService, TranslationFormatPipe} from 'common-framework';

import { RouteService } from 'common-framework';
import {DOCUMENT} from '@angular/common';
import {get} from 'lodash';
import {GeneralConfigService} from '../../services/general-config.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() showLang: boolean;
  @Input() isFullMenu: boolean;
  @Input() showLogo: boolean;
  @Input() logoSrc: string;


  @Input() isFullWidth: boolean;
  @Output() LangChangedEvent = new EventEmitter<string>();
  @Input() LangChanged;
  personName: string;
  lastLogin;
  lastFailedLogin;
  menuItems: any;
  deviceMenuItems: any[];
  defaultState;
  logo: any;
  merchantLogo: string;
  userType: string;
  pinset: string = '';
  curLang: string;
  deviceMenuTooltipItems: any[] = [];
  menuItemsTooltipItems: any[] = [];

  isrtl() {
    const dir = this.dom.querySelector('body').dir == 'rtl' ? 'rtl' : 'ltr';
    return dir == 'rtl';
  }

  constructor(@Inject(DOCUMENT) protected dom,
              protected authenticateService: AuthenticateService,
              protected router: Router,
              protected tokenStorage: TokenStorage,
              protected translationFormatPipe: TranslationFormatPipe,
              protected loaderService: LoaderService,
              protected alert: AlertService,
              protected routerService: RouteService,
              protected dataStorage: DataStorageService,
              protected generalConfigService: GeneralConfigService,
              public domainService: DomainService
  ) {
  }

  ngOnInit(): void {
    const config = JSON.parse(this.tokenStorage.getWebConfig());
    this.logo = get(config, 'logo') || this.logoSrc;
    var user = JSON.parse(this.tokenStorage.getUser());
    this.merchantLogo = user?.related_info?.image;
    this.userType = user?.user_type;
    try {
      this.lastLogin = this.tokenStorage.getLastLogin() ? JSON.parse(this.tokenStorage.getLastLogin()) : '';
    } catch (e) {
      this.lastLogin = '-';
      console.log(e);
    }

    try {
      this.lastFailedLogin = this.tokenStorage.getLastFailedLogin() ? JSON.parse(this.tokenStorage.getLastFailedLogin()) : '';
    } catch (e) {
      this.lastFailedLogin = '-';
      console.log(e);
    }
    this.menuItems = this.routerService.initMenu("my_account_menu");
    this.deviceMenuItems = this.routerService.initMenu("device_menu");
    /*if(JSON.parse(window['languages']).length>0)
    {
      console.log(JSON.parse(window['languages']));
      this.showLang = true;
    }*/
    this.defaultState = this.tokenStorage.getConfiguration();
    this.tokenStorage.getConfiguration().subscribe(res => {
      this.defaultState = get(res, 'default_state') || '/home';
    });
    this.curLang = this.tokenStorage.getCurrentLanguage();

    var namePath = 'profile.fname';
    if (this.generalConfigService.getConfig().headerConfig?.displayUserFullname) {
      namePath = 'profile.fullname';
    }
    this.personName = get(user, namePath) || '';
    this.tokenStorage.userDetailsSubject.subscribe(user => {
      if (user) {
        this.personName = get(user, namePath) || '';
      }
    });
    this.deviceMenuItems.forEach(item => {
      this.deviceMenuTooltipItems.push({
        title: this.translationFormatPipe.transform(item.title, 'menu', this.curLang),
        fctName: 'navigateTo',
        fctParams: item,
        className:'justify-content-center'
      });
    });
    this.menuItems.forEach(item => {
      this.menuItemsTooltipItems.push({
        title: this.translationFormatPipe.transform(item.title, 'menu', this.curLang),
        fctName: 'navigateTo',
        fctParams: item,
        className:'flex-row-reverse justify-content-end',
        templateRef: 'textIconItem',
        templateParams: {
          value: '',
          iconClassName: item.icon && !item.icon_path && item.icon_path == '' ? item?.icon : '',
        }
      });
    });
    this.menuItemsTooltipItems.push({
      title: 'general.logout',
      fctName: 'onLogout',
      className:'flex-row-reverse justify-content-end',
      templateRef: 'textIconItem',
      templateParams: {
        value: '',
        iconClassName: 'foo-icon foo-logout-third'
      }
    });
  }

  getRoutePath(menuItem: any): string {
    if ((this.routerService as any).isNavigationPeventedOnRoute(menuItem)) {
      return null;
    } else {
      return this.domainService.getPrefixedURL(menuItem.path);
    }
  }

  navigateTo(item: any): void {
    const routePath = this.getRoutePath(item);
    this.router.navigate([routePath]);
  }


  onItemClicked(menuItem: any): void {
    if ((this.routerService as any).isNavigationPeventedOnRoute(menuItem)) {
      (this.routerService as any).handleCustomRoute(menuItem);
    }
  }

  useLanguage() {
    var language = "en";
    if (this.tokenStorage.getCurrentLanguage() == "en") {
      language = "ar";
    }
    this.LangChangedEvent.emit(language);
    this.tokenStorage.setCurrentLanguage(language);

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.LangChanged) {
      this.curLang = this.LangChanged;
    }
  }

  onLogout() {
    this.pinset = get(this.dataStorage, 'storage.pinset'); //this.DataStorage.storage['pin_set']

    if (this.pinset == 'pin') {
      window.location.href = (window['prefix'] ? `/${window['prefix']}` : '') + '/login';
    } else {
      this.loaderService.visibility = true;
      this.authenticateService.logout().subscribe(
        (data) => {
          if (data["status"] === 'OK') {
            this.tokenStorage.clear();
            this.routerService.clearParams();
            window.location.href = (window['prefix'] ? `/${window['prefix']}` : '') + '/login';
            this.authenticateService.cancelPendingRequests();
          } else {
            this.loaderService.visibility = false;
            this.alert.emitAlert({type: "danger", text: data["message"]});

          }

        },
        error => {
          this.loaderService.visibility = false;
          this.alert.emitAlert({type: "danger", text: error["message"]});
        });
    }
  }

  checkList(list) {
    return list !== null && get(list, 'length') > 0;
  }

  goHome() {
    event.preventDefault();
    event.stopPropagation();
    if (this.defaultState !== null && this.defaultState !== undefined) {
      this.router.navigate([this.defaultState]);
    } else {
      this.router.navigate(['/home']);
    }

  }

  functionCalled($event): void {
    this[$event.functionName]($event.functionParams);
  }
}
